export enum Rabbet {
  Single = 'Single',
  Double = 'Double',
  Cased = 'Cased',
  DoubleEgress = 'Double Egress',
}
